import { atom } from "jotai";

export const showWelcomeModalAtom = atom(false);
showWelcomeModalAtom.debugLabel = "showWelcomeModalAtom";
